import { action } from "typesafe-actions";
import ActionTypes from "./constants";
import {ProductImageStacType} from "../../types/product";

export const searchStartedAction = () => action(ActionTypes.SEARCH_STARTED);

export const searchResultsSuccessAction = (data) => action(ActionTypes.SEARCH_RESULTS_SUCCESS, data);

export const searchResultsErrorAction = (error: string) => action(ActionTypes.SEARCH_RESULTS_ERROR, error);

export const resetSearchAction = () => action(ActionTypes.RESET_SEARCH);

export const toggleProductsViewAction = (data) => action(ActionTypes.TOGGLE_PRODUCTS_VIEW, data);

export const toggleFramingViewAction = (data) => action(ActionTypes.TOGGLE_FRAMING_VIEW, data);

export const updateSelectedProductsAction = (selectedProducts: ProductImageStacType[]) => action(ActionTypes.UPDATE_SELECTED_PRODUCTS, selectedProducts);

export const removeAllSelectedProductsAction = () => action(ActionTypes.REMOVE_ALL_SELECTED_PRODUCTS);

export const removeAllInterferometricStacks = () => action(ActionTypes.REMOVE_ALL_INTERFEROMETRIC_STACKS);

export const updateIsInterferometricStackSearchAction = (toggle: boolean) => action(ActionTypes.UPDATE_IS_INTERFEROMETRIC_STACK_SEARCH, toggle);
